import React from "react";

export default function Plusicon() {
  return (
    <svg width="14" height="14" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_52_17)">
        <path
          d="M799.999 323.698V476.302C799.999 487.789 790.691 497.111 779.189 497.111H497.112V779.188C497.112 790.692 487.79 799.998 476.303 799.998H323.699C312.219 799.998 302.89 790.69 302.89 779.188V497.111H20.8106C9.31362 497.111 0.000976562 487.789 0.000976562 476.302V323.698C0.000976562 312.208 9.31362 302.889 20.8106 302.889H302.89V20.8096C302.89 9.30806 312.216 0 323.699 0H476.303C487.79 0 497.112 9.30806 497.112 20.8096V302.889H779.189C790.693 302.889 799.999 312.208 799.999 323.698Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_52_17">
          <rect width="800" height="800" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
